import { Component, OnInit, Inject } from '@angular/core';
// import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintloanapplicationService } from "../../../shared/print/printloanapplication.service";

import autoTable from 'jspdf-autotable'

@Component({
  selector: 'app-rptloanapplicationpopup',
  templateUrl: './rptloanapplicationpopup.component.html',
  styleUrls: ['./rptloanapplicationpopup.component.css']
})
export class RptloanapplicationpopupComponent implements OnInit {

  // FromDate :   string ;
  LoanTypeList: any[] = [];
  SchemeList: any[] = [];
  BranchList: any[] = [];
  CentreList: any[] = [];
  CategoryList: any[] = [];

  constructor(public dialogRef: MatDialogRef<RptloanpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printloanapplicationService: PrintloanapplicationService,
    // public datePipe: DatePipe,
    ) { }

  ngOnInit() {
  
 //  this.FromDate= this.datePipe.transform(new Date(), 'dd-MM-yyyy');

    // this.data.LoanFromDate =  this.datePipe.transform(new Date()).toString();

    this.GetScheme()
    this.GetLoanType();
    this.GetBranch();
    this.GetCentre();
    this.GetCategory();
  }

  GenerateReports(): void {
    this.data.ReportName = "LoanApplicationReport";
    this.printloanapplicationService.getRptLoanList(this.data);
    this.dialogRef.close();
  }

  GetScheme() {
    this.CommonmastersService.FetchScheme().subscribe(data => {
      this.SchemeList = data;

      data.SchemeId = 0;
    })
  }

  GetLoanType() {
    this.CommonmastersService.FetchLoanType().subscribe(data => {
      this.LoanTypeList = data;

      data.TypeId =0;
    })
  }

  GetCategory() {
    this.CommonmastersService.GetCategoryList().subscribe(data => {
      this.CategoryList = data;
      data.LoanCategoryId = 0;
    })
  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
      this.data.BranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    })
  }

  GetCentre() {
    this.CommonmastersService.FetchCenterList().subscribe(data => {
      this.CentreList = data;

      data.CentreId =0;
    })
  }

}
